import { Reveal, SectionLabel } from "@/components/Reveal";

export default function WhyRound() {
    return (
        <section
            id="why"
            className="relative mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32"
            data-testid="why-round"
        >
            <Reveal>
                <SectionLabel index="01">Why This Round Matters</SectionLabel>
            </Reveal>

            <div className="grid gap-12 md:grid-cols-12">
                <div className="md:col-span-7">
                    <Reveal delay={0.1}>
                        <h2 className="font-display text-3xl md:text-5xl font-light leading-tight tracking-tight text-white">
                            This raise funds{" "}
                            <span className="italic text-gold">Phase 1</span>: the
                            MVP and product-market fit. It is the on-ramp to two
                            much larger phases that follow.
                        </h2>
                    </Reveal>
                </div>

                <div className="space-y-6 md:col-span-5">
                    <Reveal delay={0.2}>
                        <p className="text-base md:text-lg leading-relaxed text-white/70">
                            Phase 1 hits $2M in revenue on the $88 guided plan
                            through a focused B2B2C motion: mid-market employers
                            (50–500), estate attorneys, insurance brokers, and
                            real estate brokers. That milestone de-risks the model,
                            validates unit economics, and locks product-market fit.
                        </p>
                    </Reveal>
                    <Reveal delay={0.3}>
                        <p className="border-l-2 border-gold/50 pl-6 text-base md:text-lg leading-relaxed text-white/90">
                            The real prize is what comes next: an agentic estate
                            companion in Phase 2 that turns $88 entries into
                            recurring subscription revenue, and agentic trustees
                            in Phase 3 that custody multi-generational wealth.
                            Investors are underwriting a specific near-term
                            outcome that opens a category-defining trajectory.
                        </p>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
